"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _utils = require("ui-addon-upgrades/utils");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIModal = _interopRequireDefault(require("UIComponents/dialog/UIModal"));

var _UIDialogCloseButton = _interopRequireDefault(require("UIComponents/dialog/UIDialogCloseButton"));

var _UIImage = _interopRequireDefault(require("UIComponents/image/UIImage"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H3"));

var _UIScrollContainer = _interopRequireDefault(require("UIComponents/scroll/UIScrollContainer"));

var _H2 = _interopRequireDefault(require("UIComponents/elements/headings/H6"));

var _colors = require("HubStyleTokens/colors");

var _ImmutableMerchandiseIdMap = _interopRequireDefault(require("self-service-api/constants/ImmutableMerchandiseIdMap"));

var _FeaturesMap = _interopRequireDefault(require("self-service-api/constants/FeaturesMap"));

var _HubMap = _interopRequireDefault(require("self-service-api/constants/HubMap"));

var _ProductCatalogTableCell = _interopRequireDefault(require("ui-addon-upgrades/_core/productCatalog/ProductCatalogTableCell"));

var _ProductCatalogTableRow = _interopRequireDefault(require("ui-addon-upgrades/_core/productCatalog/ProductCatalogTableRow"));

var _ProductPageIcons = _interopRequireDefault(require("ui-addon-upgrades/_core/productPage/ProductPageIcons"));

var _FooterMicrocopy = _interopRequireDefault(require("ui-addon-upgrades/_core/common/components/FooterMicrocopy"));

var _responsiveBreakpoints = _interopRequireDefault(require("ui-addon-upgrades/_core/utils/responsiveBreakpoints"));

var _utils2 = require("../../utils");

var _partial = _interopRequireDefault(require("react-utils/partial"));

var PurchaseTypes = _interopRequireWildcard(require("self-service-api/constants/PurchaseTypes"));

function _templateObject8() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  color: #0091ae;\n  font-size: 18px;\n  font-weight: 600;\n  margin-right: 3px;\n  cursor: pointer;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    display: block;\n    padding: 1rem 0;\n  "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    display: flex;\n  "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: none;\n  width: 90%;\n  margin: 0 auto;\n  padding: 2rem 0;\n  text-align: center;\n\n  button {\n    font-size: 0.75rem;\n    cursor: pointer;\n    padding: calc(1rem + 1px) 2rem;\n    background: #fff;\n    border: 1px solid #7fd1de;\n    flex-basis: 25%;\n    margin-right: -1px;\n    text-align: center;\n    transition: background-color 0.3s;\n    &:hover {\n      background-color: #e5f5f8;\n    }\n    &.active {\n      font-weight: 500;\n      padding: 1rem 2rem;\n      border-width: 2px;\n      border-color: #00a4bd;\n      background-color: #e5f5f8;\n    }\n  }\n  button:first-child {\n    border-radius: 3px 0 0 3px;\n  }\n  button:last-child {\n    border-radius: 0 3px 3px 0;\n    margin-right: 0;\n  }\n  ul {\n    display: none;\n    list-style: none;\n    padding: 0;\n    width: 60%;\n    margin: 0 auto;\n    text-align: left;\n    li {\n      font-size: 16px;\n      cursor: pointer;\n      color: #0091ae;\n    }\n  }\n  #tierToggle {\n    position: absolute;\n    top: -9999px;\n    left: -9999px;\n  }\n  input[type='checkbox']:checked ~ label ~ ul {\n    display: block;\n  }\n  ", ";\n  ", ";\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  border-spacing: 0;\n  width: 100%;\n  margin-bottom: 0;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  padding: 20px;\n  background-color: ", ";\n  height: 50px;\n  text-align: center;\n  width: 18.75%;\n  min-width: 175px;\n\n  & > h6 {\n    margin: 0;\n  }\n\n  :first-child {\n    padding: 0;\n    width: 2%;\n    min-width: 30px;\n  }\n\n  :nth-child(2) {\n    padding-left: 0;\n    width: 25%;\n    text-align: left;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  text-align: center;\n  background-color: ", ";\n  padding: 20px 0;\n  & > h3 {\n    margin: 0;\n  }\n\n  img {\n    height: 20px;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  box-shadow: 0 2px 4px 0 rgba(37, 37, 37, 0.2);\n  z-index: 100;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var MODAL_WIDTH = 1200;
var HEADER_HEIGHT = 128;
var MODAL_TOP_MARGIN = 60;
var MODAL_BOTTOM_MARGIN = 47;

var HeaderSection = _styledComponents.default.div.withConfig({
  displayName: "ProductCatalogModal__HeaderSection",
  componentId: "sc-1sib4uh-0"
})(_templateObject());

var ModalHeader = _styledComponents.default.div.withConfig({
  displayName: "ProductCatalogModal__ModalHeader",
  componentId: "sc-1sib4uh-1"
})(_templateObject2(), _colors.GYPSUM);

var TopHeaderCell = _styledComponents.default.th.withConfig({
  displayName: "ProductCatalogModal__TopHeaderCell",
  componentId: "sc-1sib4uh-2"
})(_templateObject3(), _colors.OLAF);

var Table = _styledComponents.default.table.withConfig({
  displayName: "ProductCatalogModal__Table",
  componentId: "sc-1sib4uh-3"
})(_templateObject4());

var TierSelector = _styledComponents.default.div.withConfig({
  displayName: "ProductCatalogModal__TierSelector",
  componentId: "sc-1sib4uh-4"
})(_templateObject5(), _responsiveBreakpoints.default.tabletPortrait(_templateObject6()), _responsiveBreakpoints.default.phone(_templateObject7()));

var TierSelected = _styledComponents.default.label.withConfig({
  displayName: "ProductCatalogModal__TierSelected",
  componentId: "sc-1sib4uh-5"
})(_templateObject8());

var ProductCatalogModal =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(ProductCatalogModal, _React$Component);

  function ProductCatalogModal() {
    var _this;

    (0, _classCallCheck2.default)(this, ProductCatalogModal);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ProductCatalogModal).call(this));

    _this.handleTierSelect = function (keyToSet) {
      _this.setState({
        activeColumn: keyToSet
      });
    };

    _this.handleWindowSizeChange = function () {
      _this.setState({
        width: window.innerWidth
      });
    };

    _this.state = {
      width: window.innerWidth,
      activeColumn: 0
    };
    return _this;
  }

  (0, _createClass2.default)(ProductCatalogModal, [{
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      var _this2 = this;

      var resizeWindow = (0, _utils2.debounce)(function () {
        _this2.handleWindowSizeChange();
      }, 250);
      window.addEventListener('resize', resizeWindow);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleWindowSizeChange);
    }
  }, {
    key: "renderTableRows",
    value: function renderTableRows() {
      var hub = this.props.hub;
      var highlightedFreeMerch = _HubMap.default[hub].highlightedFreeMerch;
      var orderedMerchIdsForHub = [].concat((0, _toConsumableArray2.default)(highlightedFreeMerch ? [highlightedFreeMerch] : []), (0, _toConsumableArray2.default)(_HubMap.default[hub].highlightedPaidMerch));
      var enterpriseFeatureIds = Object.keys(_ImmutableMerchandiseIdMap.default[(0, _utils.last)(orderedMerchIdsForHub)].features);
      return enterpriseFeatureIds.map(function (featureId, i) {
        return _react.default.createElement(_ProductCatalogTableRow.default, {
          featureId: featureId,
          key: i,
          hub: hub,
          freeUserAccess: _FeaturesMap.default[featureId] && _HubMap.default[hub].merchPurchaseType === PurchaseTypes.SEAT_BASED && _FeaturesMap.default[featureId].freeUser
        }, orderedMerchIdsForHub.map(function (merchId, j) {
          return _react.default.createElement(_ProductCatalogTableCell.default, {
            featureId: featureId,
            merchandiseId: merchId,
            key: j
          });
        }));
      });
    }
  }, {
    key: "renderMobileTableRows",
    value: function renderMobileTableRows() {
      var _this3 = this;

      var hub = this.props.hub;
      var highlightedFreeMerch = _HubMap.default[hub].highlightedFreeMerch;
      var orderedMerchIdsForHub = [].concat((0, _toConsumableArray2.default)(highlightedFreeMerch ? [highlightedFreeMerch] : []), (0, _toConsumableArray2.default)(_HubMap.default[hub].highlightedPaidMerch));
      var enterpriseFeatureIds = Object.keys(_ImmutableMerchandiseIdMap.default[(0, _utils.last)(orderedMerchIdsForHub)].features);
      return enterpriseFeatureIds.map(function (featureId, i) {
        // TODO Hiding the tooltips on mobile for now since they jump off the screen.
        //  Will probably need a different solution to better present the extra info on mobile
        return _react.default.createElement(_ProductCatalogTableRow.default, {
          featureId: featureId,
          key: i,
          hub: hub,
          freeUserAccess: _FeaturesMap.default[featureId] && _HubMap.default[hub].merchPurchaseType === PurchaseTypes.SEAT_BASED && _FeaturesMap.default[featureId].freeUser,
          showTooltip: false
        }, orderedMerchIdsForHub.map(function (merchId, j) {
          if (j === _this3.state.activeColumn) {
            return _react.default.createElement(_ProductCatalogTableCell.default, {
              featureId: featureId,
              merchandiseId: merchId,
              colId: j,
              showTooltip: false,
              key: j
            });
          }

          return null;
        }));
      });
    }
  }, {
    key: "renderTableHeader",
    value: function renderTableHeader(headerKeys) {
      return _react.default.createElement(Table, null, _react.default.createElement("thead", null, _react.default.createElement("tr", null, _react.default.createElement(TopHeaderCell, null), headerKeys.map(function (headerKey, i) {
        return _react.default.createElement(TopHeaderCell, {
          "data-key": i - 1,
          key: i
        }, _react.default.createElement(_H2.default, null, _react.default.createElement(_FormattedMessage.default, {
          message: "upgrades.productCatalog.tableHeader." + headerKey
        })));
      }))));
    }
  }, {
    key: "renderMobileTableHeader",
    value: function renderMobileTableHeader(headerKeys) {
      var _this4 = this;

      return _react.default.createElement(Table, null, _react.default.createElement("thead", null, _react.default.createElement("tr", null, headerKeys.map(function (headerKey, i) {
        if (i === 0 || i - 1 === _this4.state.activeColumn) {
          return _react.default.createElement(TopHeaderCell, {
            "data-key": i - 1,
            key: i
          }, _react.default.createElement(_H2.default, null, _react.default.createElement(_FormattedMessage.default, {
            message: "upgrades.productCatalog.tableHeader." + headerKey
          })));
        }

        return null;
      }))));
    }
  }, {
    key: "renderTierSelector",
    value: function renderTierSelector(headerKeys) {
      var _this5 = this;

      return _react.default.createElement(TierSelector, null, headerKeys.slice(1).map(function (headerKey, i) {
        return _react.default.createElement("button", {
          onClick: (0, _partial.default)(_this5.handleTierSelect, i),
          key: i,
          className: _this5.state.activeColumn === i ? 'active' : ''
        }, _react.default.createElement(_FormattedMessage.default, {
          message: "upgrades.productCatalog.tableHeader." + headerKey
        }));
      }));
    }
  }, {
    key: "renderPhoneTierSelector",
    value: function renderPhoneTierSelector(headerKeys) {
      var _this6 = this;

      return _react.default.createElement(TierSelector, null, _react.default.createElement("input", {
        type: "checkbox",
        id: "tierToggle"
      }), _react.default.createElement(TierSelected, {
        htmlFor: "tierToggle"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: "upgrades.productCatalog.tableHeader." + headerKeys.slice(1)[this.state.activeColumn]
      })), _react.default.createElement(_UIIcon.default, {
        name: "downCarat",
        size: "12px"
      }), _react.default.createElement("ul", null, headerKeys.slice(1).map(function (headerKey, i) {
        return _react.default.createElement("li", {
          onClick: (0, _partial.default)(_this6.handleTierSelect, i),
          key: i
        }, _react.default.createElement(_FormattedMessage.default, {
          message: "upgrades.productCatalog.tableHeader." + headerKey
        }));
      })));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          hub = _this$props.hub,
          onCloseClick = _this$props.onCloseClick;
      var highlightedFreeMerch = _HubMap.default[hub].highlightedFreeMerch ? [_HubMap.default[hub].highlightedFreeMerch] : [];
      var allEditions = [].concat(highlightedFreeMerch, (0, _toConsumableArray2.default)(_HubMap.default[hub].highlightedPaidMerch)).map(function (merch) {
        return _ImmutableMerchandiseIdMap.default[merch].edition;
      });
      var headerKeys = ['features'].concat((0, _toConsumableArray2.default)(allEditions));
      return _react.default.createElement(_UIModal.default, {
        use: "conversational",
        width: MODAL_WIDTH,
        style: {
          overflow: 'hidden'
        },
        "data-selenium-id": "product-catalog-" + hub
      }, _react.default.createElement(HeaderSection, null, _react.default.createElement(ModalHeader, null, _react.default.createElement(_UIImage.default, {
        className: "display-inline m-right-2 m-bottom-2",
        src: _ProductPageIcons.default[hub]
      }), _react.default.createElement(_H.default, {
        className: "display-inline"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: "pricing-pages.hubs." + hub + ".name"
      })), _react.default.createElement(_UIDialogCloseButton.default, {
        onClick: (0, _partial.default)(onCloseClick),
        "data-selenium-id": "product-catalog-close-" + hub
      }))), _react.default.createElement(_react.default.Fragment, null, this.state.width <= 500 ? this.renderPhoneTierSelector(headerKeys) : this.renderTierSelector(headerKeys), _react.default.createElement("div", null, this.state.width <= 800 ? this.renderMobileTableHeader(headerKeys) : this.renderTableHeader(headerKeys), _react.default.createElement(_UIScrollContainer.default, {
        maxHeight: "calc(100vh - " + (HEADER_HEIGHT + MODAL_TOP_MARGIN + MODAL_BOTTOM_MARGIN) + "px)",
        scrollDirection: 'vertical'
      }, _react.default.createElement(Table, null, _react.default.createElement("tbody", null, this.state.width <= 800 ? this.renderMobileTableRows() : this.renderTableRows())), _react.default.createElement(_FooterMicrocopy.default, null)))));
    }
  }]);
  return ProductCatalogModal;
}(_react.default.Component);

ProductCatalogModal.propTypes = {
  hub: _propTypes.default.string.isRequired,
  onCloseClick: _propTypes.default.func.isRequired
};
var _default = ProductCatalogModal;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.2952/js/_core/productCatalog/ProductCatalogModal.js
// module id = 691
// module chunks = 5 6